import * as React from "react";
import {useNavigate} from "react-router-dom";

import "./index.scss";

// Separatori e "<" scritti a mano nelle pagine li disegna già il componente
const SEPARATORS = ["/", "<"];

export default function Breadcrumbs(props) {
	const {
		listElements,
		currentListElement,
		elements,
		actions,
		current,
		noPadding = false,
	} = props;

	const navigate = useNavigate();

	const crumbs = (elements || []).filter(
		(bE) => bE?.label && !SEPARATORS.includes(bE.label),
	);
	// Senza titolo esplicito, l'ultima voce senza collegamento è il titolo della pagina
	let title = current;
	if (!title && crumbs.length && !crumbs[crumbs.length - 1].path) {
		title = crumbs.pop().label;
	}

	let render = (
		<nav
			aria-label="Percorso"
			className={
				"breadcrumbs-container" +
				(crumbs.length || title ? " not-empty" : "") +
				(listElements ? " tabbed" : "")
			}
		>
			{crumbs.map((bE, k) => (
				<React.Fragment key={k}>
					{bE.path ? (
						<button
							type="button"
							className="bc-element clickable"
							onClick={() => navigate(bE.path)}
						>
							{bE.label}
						</button>
					) : (
						<span className="bc-element">{bE.label}</span>
					)}
					<span className="bc-separator" aria-hidden="true">
						/
					</span>
				</React.Fragment>
			))}
			{title && (
				<h1 className="bc-element current" aria-current="page">
					{title}
				</h1>
			)}
			{listElements?.map((lE, k) => {
				return (
					<div
						key={k}
						className={
							"tab-element clickable" +
							(currentListElement === lE.value ? " selected" : "")
						}
						onClick={lE.onClick}
					>
						{lE.label}
					</div>
				);
			})}
		</nav>
	);

	return (
		<div className="row no-margin">
			<div className={"col-sm-12" + (!noPadding ? " padding-small" : "")}>
				<div
					className={
						"d-flex justify-content-between breadcrumbs-block-container" +
						(!crumbs.length && !title ? " empty" : "")
					}
				>
					{render}
					{actions}
				</div>
			</div>
		</div>
	);
}
